import useTypedSWR from 'src/components/general/useTypedSWR';
import { LOAD_PATIENT_ASSESSMENTS } from 'src/events/hooks/usePatientAssessments.gql';

export const usePatientAssessments = (patientId?: string | null) => {
  const { data } = useTypedSWR(patientId ? [LOAD_PATIENT_ASSESSMENTS, { patientId }] : null);
  if (!patientId) return { assessments: [] };
  const assessments = data?.staff_getRecentlyCompletedPatientAssessments ?? [];
  return { assessments };
};
